import { Tag } from "antd";
import type { AidRecordStatus } from "../types";

export const statusLabels: Record<AidRecordStatus, string> = {
	pending: "Kutilmoqda",
	approved: "Tasdiqlangan",
	rejected: "Rad etilgan",
};

const statusColors: Record<AidRecordStatus, string> = {
	pending: "gold",
	approved: "green",
	rejected: "red",
};

export const statusOptions = (Object.keys(statusLabels) as AidRecordStatus[]).map((value) => ({
	value,
	label: statusLabels[value],
}));

interface StatusTagProps {
	status: AidRecordStatus;
}

export function StatusTag({ status }: StatusTagProps) {
	return (
		<Tag bordered={false} color={statusColors[status]}>
			{statusLabels[status]}
		</Tag>
	);
}
